const capitalize = (string: string): string => {
  return string
    ?.split(' ')
    ?.map((word: string) => `${word?.[0]?.toUpperCase()}${word?.slice(1)}`)
    ?.join(' ');
};

export default capitalize;
